import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fleetcompleteConfig: TSPConfig = {
  key: 'fleetcomplete',
  name: 'Fleet Complete Web',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>
        Note: If you have transitioned to Fleet Complete Hub, please choose that
        option.
      </li>
      <li>
        Log into your Fleet Complete account at{' '}
        <a target='_self' href='https://web.fleetcomplete.com/login'>
          https://web.fleetcomplete.com/login
        </a>
        .
        <ol>
          <li>
            Go to the Settings section and click on the "My Profile" icon.{' '}
          </li>
          <li>
            Under "General", it will show the username under "Name" and the
            Client ID under "Client ID" that are needed in order to connect your
            Fleet Complete account.
          </li>
        </ol>
      </li>
      <li>Input your Fleet Complete username, password, and Client ID. </li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        { label: 'Client ID', name: 'database', type: 'text', required: true },
        {
          label: 'Fleet Name (Optional)',
          name: 'carrier',
          type: 'text',
          required: false,
        },
        {
          label: 'DOT Number (Optional)',
          name: 'dot',
          type: 'number',
          required: false,
        },
      ]}
    />
  ),
};

export default fleetcompleteConfig;
